<template>
    <ul class="m-d-0 f-c-midgrey">
        <li v-if="criteria.filter_by === 'periode'">
            <span class="f-bold">Tanggal transaksi:</span>
            <span> {{ $moment(criteria.tanggal_awal).format("Do MMM YYYY") }} </span>
            <span> s.d </span>
            <span> {{ $moment(criteria.tanggal_akhir).format("Do MMM YYYY") }} </span>
        </li>
        <li v-if="criteria.filter_by === 'bulan'">
            <span class="f-bold">Periode transaksi:</span>
            <span> {{ $moment(criteria.bulan).format("MMM YYYY") }} </span>
        </li>
        <li v-if="criteria.filter_by === 'tahun'">
            <span class="f-bold">Tahun transaksi:</span>
            <span> {{ $moment(criteria.tahun).format("YYYY") }} </span>
        </li>
        <li v-if="filterJenisTransaksi && filterJenisTransaksi.length > 0">
            <span class="f-bold">Jenis transaksi:</span>
            <span v-for="(jt, idx) in filterJenisTransaksi" :key="`${idx}-jt`">
                {{ getJenisTransaksi(jt) }}{{ filterJenisTransaksi.length - 1 > idx ? "," : "" }}
            </span>
        </li>
        <li v-if="filterStatusTransaksi && filterStatusTransaksi.length > 0">
            <span class="f-bold">Status transaksi:</span>
            <span v-for="(st, idx) in filterStatusTransaksi" :key="`${idx}-st`">
                {{ getStatusTransaksi(st) }}{{ filterStatusTransaksi.length - 1 > idx ? "," : "" }}
            </span>
        </li>
        <li v-if="filterStatusBayar && filterStatusBayar.length > 0">
            <span class="f-bold">Status bayar:</span>
            <span v-for="(sb, idx) in filterStatusBayar" :key="`${idx}-sb`">
                {{ getStatusBayar(sb) }}{{ filterStatusBayar.length - 1 > idx ? "," : "" }}
            </span>
        </li>
        <li v-if="filterOutlet && filterOutlet.length > 0">
            <span class="f-bold">Transaksi di:</span>
            <span v-for="(outlet, idx) in filterOutlet" :key="`${idx}-outlet`">
                {{ getNamaOutlet(outlet) }}{{ filterOutlet.length - 1 > idx ? "," : "" }}
            </span>
        </li>
        <li v-if="criteria.idkaryawan">
            <span class="f-bold">Dibuat oleh:</span>
            <span> "{{ getNamaKaryawan(criteria.idkaryawan) }}"</span>
        </li>
        <li v-if="criteria.idkonsumen_array && criteria.idkonsumen_array.length > 0">
            <span class="f-bold">Transaksi oleh konsumen:</span>
            <span v-for="(konsumen, idx) in criteria.idkonsumen_array" :key="`${idx}-outlet`">
                {{ getNamaKonsumen(konsumen) }}{{ criteria.idkonsumen_array.length - 1 > idx ? "," : "" }}
            </span>
        </li>
    </ul>
</template>
<script>
import { mapGetters } from "vuex";
import { moduleName } from "../store/state";
import filterOptions from "../static/filterOptions";

export default {
    name: "CriteriaAddInvoice",
    props: {
        criteria: {
            type: Object,
            required: true,
        },
    },
    computed: {
        ...mapGetters(moduleName, {
            isFilter: "isFilter",
        }),
        ...mapGetters("outletModule", {
            outlets: "getOutlet",
        }),
        ...mapGetters("metaModule", {
            dataKaryaway: "getKaryawanAll",
        }),
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        dataOutlet() {
            return this.outlets.data;
        },
        filterJenisTransaksi() {
            return this.criteria.jenis_transaksi_array;
        },
        filterStatusTransaksi() {
            return this.criteria.status_tahapan_array;
        },
        filterStatusBayar() {
            return this.criteria.status_pembayaran_array;
        },
        filterOutlet() {
            return this.criteria.idoutlet_array;
        },
        getNamaOutlet() {
            return function (id) {
                let outlet = this.dataOutlet.find((data) => data.idoutlet === id);
                return outlet?.nama || "";
            };
        },
        getNamaKonsumen() {
            return function (id) {
                let konsumen = this.filterItem.konsumen.find((data) => data.id === id);
                return konsumen?.label || "";
            };
        },
        getNamaKaryawan() {
            return function (id) {
                let karyawan = this.dataKaryaway.find((data) => data.idkaryawan === id);
                return karyawan?.nama || "";
            };
        },
        getJenisTransaksi() {
            return function (val) {
                let jt = filterOptions.jenisTransaksi.find((data) => data.value === val);
                return jt?.title || "";
            };
        },
        getStatusTransaksi() {
            return function (val) {
                let st = filterOptions.statusTransaksi.find((data) => data.value === val);
                return st?.title || "";
            };
        },
        getStatusBayar() {
            return function (val) {
                let sb = filterOptions.statusBayarAdd.find((data) => data.value === val);
                return sb?.title || "";
            };
        },
    },
    methods: {
        setDataOutlet(datas) {
            if (datas && datas.length > 0) {
                this.dataOutlet = [];
                datas.forEach((data) => {
                    this.dataOutlet.push(data);
                });
            }
        },
        setDataKaryawan(datas) {
            if (datas && datas.length > 0) {
                this.dataKaryaway = [];
                datas.forEach((data) => {
                    this.dataKaryaway.push(data);
                });
            }
        },
    },
};
</script>
